import { BEAT_TYPES } from './constants'

const registry = new Map()

const defaults = {
  [BEAT_TYPES.NARRATIVE]: {
    label: 'Narrative',
    description: 'Story content delivered to the learner',
    requiresInteraction: false,
    advanceAction: 'next',
  },
  [BEAT_TYPES.INPUT]: {
    label: 'Input',
    description: 'Learner provides a text or media response',
    requiresInteraction: false,
    advanceAction: 'next',
  },
  [BEAT_TYPES.DECISION]: {
    label: 'Decision',
    description: 'Learner chooses between options',
    requiresInteraction: false,
    advanceAction: 'next',
  },
  [BEAT_TYPES.CHARACTER_RESPONSE]: {
    label: 'Character Response',
    description: 'AI-generated in-character reactions from story characters',
    requiresInteraction: false,
    advanceAction: 'next',
  },
  [BEAT_TYPES.NARRATIVE_RESPONSE]: {
    label: 'Narrative Response',
    description: 'AI-generated narrator commentary on player choices',
    requiresInteraction: false,
    advanceAction: 'next',
  },
  [BEAT_TYPES.RESOLUTION]: {
    label: 'Resolution',
    description: 'AI-generated narrative conclusion synthesizing the player journey',
    requiresInteraction: false,
    advanceAction: 'next',
  },
}

// Seed defaults
Object.entries(defaults).forEach(([type, def]) => registry.set(type, def))

export const getBeatTypeDef = (type) =>
  registry.get(type) || registry.get(BEAT_TYPES.NARRATIVE)

export const registerBeatType = (type, def) => {
  registry.set(type, def)
}

export const getAllBeatTypes = () =>
  Array.from(registry.entries()).map(([value, def]) => ({ value, ...def }))
